import styled from 'astroturf/react';
import Svg from 'src/components/Svg';

const ActionStatusWrapper = styled('div')`
  padding-top: 10px;
  padding-right: 20px;
  width: 25%;

  @media (max-width: 1024px) {
    width: 40%;
    padding-left: 20px;
  }

  [class*='actionStatusWrapper'] {
    border-width: 0.5px !important;
    top: 12px;
    position: relative;

    [class*='react-select__value-container'] {
      border-radius: 0px;
      left: -5px;
      
      input {
        caret-color: transparent;
      }
    }

    [class*='react-select__control'] {
      background: var(--white);
      min-height: 28px;
      height: 28px;

      [class*='bg-plum-100'] {
        background: var(--plum-100);
      }

      [class*='bg-lemon-100'] {
        background: var(--medium-yellow);
      }

      [class*='bg-plum-100'] {
        background: var(--plum-100);
      }

      [class*='bg-aqua-100'] {
        background: var(--ph-aqua-100);
      }

      [class*='chips-wrapper'] {
        border-radius: 0px;
        min-width: 240px;
        top: 17px;
        position: relative;
        height: 22px;
        
        @media screen and (min-width: 1570px) {
          top: 0px;
        }

        div {
          position: relative;
          top: -4px;

          span {
            font-size: 11px;
            font-family: var(--ph-font-family-lato-regular);
          }
        }
      }

      [class*='react-select__indicators'] {
        background: var(--white);
      }
    }
  }
`;

const ResourceDropdownWrapper = styled('div')`
width: 50%;

label{
  font-family: var(--ph-font-family-source-sans-pro-semibold) !important;
  font-size: 11px !important;
  color: var(--dark-blue) !important;
  &::before {
    content: " ";
    height: 1em;
    width: 1em;
    clip-path: circle(2px at center);
    background-color: var(--cyan-green);
    display:inline-block;
    top: 2px;
    position: relative;
  }
}
[class*='react-select__value-container']{  
  width: 100%;
  height: 38px;
}
[class*='react-select__input-container']{
  position: absolute;
}
[class*='react-select__control']{
  min-height: 20px;
  height: 26px;
}
[class*='react-select__single-value']{
  padding: 0;
  margin: 0;
  font-size: 11px;
}
`;

const ResourceFlex = styled('div')`
  display: flex;
  flex-direction: row;

  [class*='rightToDropdown']{
    width: 50%;
    padding: 0;
    margin-left: 5px;
  }
  [class*='InputWrapper'] {
    margin-left: 0px !important;
  }
`;

const AddCommentIcon = styled(Svg)`
  width: 18px;
  top: 4px;
  left: 7px;
  cursor: pointer;
`;

const AddCommentInput = styled('div')`
  padding-top: 10px;

  [class*='editableText'] {
    padding-left: 10px !important;
  }
`;

const CapActionContainer = styled('div')`
  margin-left: 15px;
  margin-right: 15px;
  border: 0.5px solid var(--dark-blue);
  margin-bottom: 20px;

  [class*='d-flex'] {
    display: flex;
  }

  [class*='pr-20'] {
    padding-right: 20px;
  }

  [class*='custom-date-picker'] { 
    margin-bottom: 0px;
    margin-left: -6px;

    [class*='react-datepicker-wrapper'] {
      height: 0px;
    }

    [class*='react-datepicker__current-month'] {
      font-size: 11px !important;
      font-family: var(--ph-font-family-lato-bold);
    }

    [class*='react-datepicker__navigation-icon'] {
      &::before {
        border-width: 1.5px 1.5px 0 0;
        height: 6px;
        width: 6px;
        border-color: var(--dark-blue) !important;
      }
    }

    [class*='react-datepicker__header'] {
      border-bottom: none;
    }

    [class*='react-datepicker__day-name'] {
      color: var(--light-gray) !important;
      font-size: 11px !important;
      font-family: var(--ph-font-family-lato-regular) !important;
    }

    [class*='react-datepicker__day'] {
      color: var(--dark-blue);
      font-size: 11px;
      font-family: var(--ph-font-family-lato-regular);

      [class*='react-datepicker__day--selected'] {
        color: var(--white);
      }
    }

    [class*='Select-arrow'] {
      display: none;
    }
  }

  [class*='eiqWrapper'] {
    margin-bottom: 0px !important;

    &[class*='InputWrapper'] {
      margin-left: -5px;
    }

    &[class*='DescriptionInputWrapper'] {
      margin-left: 9px;
    }

    &[class*='CommentInputWrapper'] {
      margin-left: 4px;
    }

    textarea {
      line-height: 22px;
    }

    input {
      height: 24px;
    }

    input, textarea {
      overflow: hidden;
      border: none;
      background: transparent;
      font-size: 11px;
      cursor: pointer;
      padding-left: 5px !important;

      &::placeholder {
        color: var(--ph-gray-450) !important;
        font-style: italic !important;
      }

      &:focus {
        border: 1.5px solid var(--dark-blue) !important;
      }

      &:hover {
        background: rgba(var(--ph-dark-blue-rgb), 0.1);
      }

      &:disabled {
        background: transparent;
        cursor: default;
      }
    }
  }
`;

const CapActionDetailsWrapper = styled('div')``;

const CapActionHeader = styled('div')`
  background: var(--cyan-green);
  display: flex;
  justify-content: space-between;
`;

const CapBriefSection = styled('div')`
  display: flex;
  justify-content: space-between;
  background: rgba(var(--ph-cyan-green-rgb), 0.1);

  @media (max-width: 1024px) {
    display: grid;
  }
  
  ul {
    display: flex;
    padding:10px;

    :last-child {
      border-right: none;
    }

    li {
      display: inline-block;
      padding: 2px 20px;
      min-width: 148px;
      border-right: 0.5px solid var(--dark-blue);
      
      &:first-child {
        padding-left:13px;
      }

      &:last-child {
        border-right: none;
      }
    }
  }
`;

const CapDetailSection = styled('div')`
  display:flex;
  padding-bottom: 15px;
  padding-top: 5px;
`;

const CollapseIcon = styled(Svg)`
  height: 15px;
  width: 15px;

  &:hover {
    opacity: 1;
    background: var(--cyan-vivid);
  }
`;

const CollapsableWrapper = styled('button')`
  cursor: default;
  background-color: transparent !important;
`;

const DeleteActionWrapper = styled('div')`
  margin-top: 20px;
  padding-left: 10px;

  [class*='button-wrapper'] {
    border-color: var(--ph-red-500);
    color: var(--ph-red-500);
    font-family: var(--ph-font-family-lato-bold);
    font-size: 13px;

    &:hover {
      span {
        border-color: var(--ph-red-500) !important;
      }
    }
  }
`;

const DetailWrapper = styled('div')`
  padding-left: 8px;

  &[class*='pl-0'] {
    padding-left: 0px;
  }

  [class*='pl-8'] {
    padding-left: 8px;
  }
`;

const ResourceDetailWrapper = styled('div')`
  padding-left: 22px;
  
  &[class*='DescriptionInputWrapper'] {
    margin-left: 0px;
  }
  [class*='resourceInputWrapper'] {
    margin-left: 9px !important;
  }
  
  input[type=number]{
    -moz-appearance: textfield;
    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }      
  }
  
  &[class*='flex']{
    padding-left: 0px;
    display: flex;
    flex-direction: row;
  }
`;
const ResourceLabel = styled('span')`
  font-size: 11px;
  font-family: var(--ph-font-family-source-sans-pro-regular);
  color: var(--dark-blue);
  padding-top: 3px;
  margin-left: 10px;
`;
const ResourceTitleLabel = styled('h3')`
  font-family: var(--ph-font-family-source-sans-pro-semibold);
  font-size: 11px;
  color: var(--dark-blue);
  padding-top: 7px;
  padding-bottom: 6px;
    &[class*='mandatory'] {
      &::before {
        content: " ";
        height: 1em;
        width: 1em;
        clip-path: circle(2px at center);
        background-color: var(--cyan-green);
        display:inline-block;
        top: 2px;
        position: relative;
      }
    }
`;

const Comment = styled('p')`
  padding-top: 10px;
  font-size: 11px;
  line-height: 15px;
  padding-left: 0px;
  font-family: var(--ph-font-family-source-sans-pro-regular);
`;

const CommentDate = styled('span')`
  font-size: 11px;
  font-family: var(--ph-font-family-source-sans-pro-regular);
  position: relative;
  top: -3px;
  padding-left: 5px;
  color: var(--dark-black);
`;

const Content = styled('p')`
  font-size: 11px;
  line-height: 15px;
  padding: 5px 14px 0px 0px;
  font-family: var(--ph-font-family-source-sans-pro-regular);
`;

const ErrorMessageWrapper =  styled('span')`
  font-size: 11px;
  color: var(--ph-red-500);
`;

const ExpandIcon = styled(Svg)`
  cursor: pointer;
  height: 15px;
  width: 15px;

  &:hover {
    opacity: 1;
    background: var(--cyan-vivid);
  }
`;

const LeftSection = styled('div')`
  width: 70%;
  padding-right: 20px;
  border-right: 0.5px solid var(--dark-blue);
`;

const ResourceWrapper = styled('div')`
  background: var(--light-white);
  padding: 5px;
  margin-bottom: 15px;
  border-radius: 2px;
  margin-top: 5px;    
  max-height: 0;
  transition: max-height 0.3s ease-in-out;
  &[class*='collapsable']{
    background: var(--white);
  }
  &.expanded {
    max-height: 500px;
  }

  [class*='checkbox-wrapper'] {
    input[type=checkbox][disabled]{
      display: none;
    }
    span {
      color: var(--dark-blue);
      font-size: 14px !important;
      font-family: var(--ph-font-family-lato-bold);
    }
  }
`;

const RightSection = styled('div')`
  width:30%;
  padding: 0 14px;
`;

const Separator = styled('span')`
  border-left: 0.5px solid var(--dark-black);
  height: var(--ph-text-xs);
  margin-left: 5px;
`;

const Text = styled('p')`
  font-family: var(--ph-font-family-lato-regular);
  font-size: 11px;
  padding-top: 4px
`;

const Title = styled('h3')`
  font-family: var(--ph-font-family-lato-bold);
  font-size: var(--ph-heading-size);
  color: var(--dark-blue);
  padding-top: 7px;
    &[class*='desc-title'] {
      &::before {
        content: " ";
        height: 1em;
        width: 1em;
        clip-path: circle(2px at center);
        background-color: var(--cyan-green);
        display:inline-block;
        top: 2px;
        position: relative;
      }
    }
`;

const TitleSmall = styled('h4')`
  font-family: var(--ph-font-family-source-sans-pro-semibold);
  color: var(--dark-blue);
  font-size: 11px;
  position:relative;
    &::before {
      content: " ";
      height: 1em;
      width: 1em;
      clip-path: circle(2px at center);
      background-color: var(--cyan-green);
      top: 1px;
      position: absolute;
      left: -13px;
    }
   &[class*='not-mandatory'] {
    &::before {
      display: none;
    }
   }
`;

const ToggleWrapper = styled('div')`
  [class*='pl-13'] {
    padding-left:13px;
  }

  [class*='pl-10'] {
    padding-left: 10px;
  }

  [class*='editableText'] {
    margin-left: 0px;

    span {
      font-style: italic;
      color: var(--ph-gray-450);
    }

    &:hover {
      margin-left: 0px !important;
    }
  }

  [class*='collapsable'] {
    overflow: hidden;
    max-height: 0;
    transition: max-height 0.5s ease-in-out;
  }  
  &.overflow{
    [class*='collapsable']{
      overflow: hidden !important;
    }
    [class*='collapsable expanded']{
      overflow: inherit !important;
    }
  }

  [class*='expanded'] {
    max-height: 3000px;
    transition: max-height 0.7s ease-in-out;
  }
`;


export default {
  ActionStatusWrapper,
  AddCommentIcon,
  AddCommentInput,
  CapActionContainer,
  CapActionDetailsWrapper,
  CapActionHeader,
  CapBriefSection,
  CapDetailSection,
  CollapseIcon,
  CollapsableWrapper,
  Comment,
  CommentDate,
  Content,
  DeleteActionWrapper,
  DetailWrapper,
  ExpandIcon,
  ErrorMessageWrapper,
  LeftSection,
  ResourceWrapper,
  ResourceDetailWrapper,
  ResourceLabel,
  ResourceTitleLabel,
  ResourceDropdownWrapper,
  ResourceFlex,
  RightSection,
  Separator,
  Text,
  Title,
  TitleSmall,
  ToggleWrapper
}
